import React from 'react';
import eVerifyLogo from '../assets/e-verify-logo.png';

function Partners() {
  return (
    <section id="partners" className="compliance">
      <div className="compliance-badge">
        <img src={eVerifyLogo} alt="E-Verify Participant" />
        <p>
          <strong>E-Verify Participant</strong> - Dhriti Solutions is committed to transparent, compliant hiring practices across all staffing and consulting engagements.
        </p>
      </div>
    </section>
  );
}

export default Partners;
